import { IProductCard } from '@seb/web-design-system/core';

export const productCardSkeleton: IProductCard = { title: 'title', media: { url: 'url' } };
